/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { useRef } from "react";
import { defaultTheme, Provider } from "@adobe/react-spectrum";
import AdobeIcon from "icons/dc_appicon_256.svg";
import IconCSS from "icons/Icon.css";

function handleClick(event, adobeIconRef) {
    if (event.key === "Enter") {
        // eslint-disable-next-line no-unused-expressions
        adobeIconRef.current?.click();
    }
}

const AdobeDCIcon = () => {
    const adobeIconRef = useRef(null);
    return (
        <Provider colorScheme="light" theme={ defaultTheme }>
            <div
                ref={ adobeIconRef }
                className={ IconCSS.icon }
                role="button"
                tabIndex="0"
                onKeyDown={ event => handleClick(event, adobeIconRef) }
            >
                <AdobeIcon />
            </div>
        </Provider>
    );
};

export default AdobeDCIcon;
